import { SwitchLabel } from './SwitchLabel';
import { SwitchRoot } from './SwitchRoot';

export const Switch = {
  Root: SwitchRoot,
  Label: SwitchLabel,
};
